import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';

export function getSites(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Site`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getSiteId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Site/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createSite(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('Site', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateSiteId(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Site/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function deleteSiteId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.delete(`Site/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}